import api_client from "./api_client"; // 引入封裝好的 axios 客戶端
import { toast } from "react-toastify";

//取得POS商店資料
export const getEnvAPI = async() => {
  try{
    const response = await api_client.get("/env");
    if(response.data.error === 0){
      return response.data ;
    }
  } catch(error){
    handleError(error);
  }
}

// 獲取訂單 API 函數
export const getOrders = async (params) => {
  try {
    const response = await api_client.get("/order", { params });
    return response.data.list;
  } catch (error) {
    handleError(error);
  }
};

// 預約管理
export const getReservationsAPI = async (params = {}) => {
  try {
    const response = await api_client.get("/reservations", { params });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const createReservationAPI = async (payload) => {
  try {
    const response = await api_client.post("/reservations", payload);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateReservationAPI = async (orderId, payload) => {
  try {
    const response = await api_client.put(`/reservations/${orderId}`, payload);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const releaseReservationAPI = async (orderId) => {
  try {
    const response = await api_client.post(`/reservations/${orderId}/release`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const cancelReservationAPI = async (orderId) => {
  try {
    const response = await api_client.post(`/reservations/${orderId}/cancel`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const markReservationNoShowAPI = async (orderId) => {
  try {
    const response = await api_client.post(`/reservations/${orderId}/no-show`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 依手機號碼取得顧客歷史消費（後端統計、分頁）
export const getCustomerOrdersAPI = async ({ mobile, page = 0 }) => {
  try {
    const response = await api_client.get("/customer/orders", { params: { mobile, page } });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 提交訂單 API 函數
export const submitOrderAPI = async (orderData, print) => {
  try {
    const response = await api_client.post("/buycart", {
      ...orderData,
      print: print,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// POS 開單投放到自助點餐 iPad 客顯（status: editing 顯示 / clear 清除）；失敗不影響點餐流程，靜默即可
export const kioskDisplayAPI = async ({ order_id, status = "editing" } = {}) => {
  try {
    const response = await api_client.post("/kiosk_display", { order_id, status });
    return response.data;
  } catch (error) {
    return null;
  }
};

// 結帳 API 函數
export const checkoutAPI = async (data) => {
  try {
    const response = await api_client.post("/checkout", data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 指派/更換外送員（外送單付清後 → 運送中）
export const assignShipAPI = async ({ order_id, ship_admin }) => {
  try {
    const response = await api_client.post("/ship_assign", { order_id, ship_admin });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 外送送達（運送中 → 送達，通知客人）
export const shipArrivalAPI = async ({ order_id }) => {
  try {
    const response = await api_client.post("/ship_arrival", { order_id });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 作廢付款 API 函數（付款方式輸入錯誤時用，作廢後可重新結帳）
export const voidPaymentAPI = async ({ order_id, order_pay_id, confirm_refund = false }) => {
  try {
    const response = await api_client.post("/void_payment", {
      order_id,
      order_pay_id,
      confirm_refund,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 取得會員點數明細
export const getMemberPointDetailAPI = async (params) => {
  try {
    const response = await api_client.get("/member_point/detail", { params });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 轉盤券掃碼查詢
export const getCouponAPI = async (code) => {
  try {
    const response = await api_client.get("/coupon", { params: { code } });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 轉盤券核銷（帶 order_id 同時折抵該訂單）
export const redeemCouponAPI = async ({ code, order_id }) => {
  try {
    const response = await api_client.post("/coupon/redeem", { code, order_id });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 轉盤後台 - 活動設定
export const getWheelActivityAPI = async () => {
  try {
    const response = await api_client.get("/wheel/activity");
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const saveWheelActivityAPI = async (data) => {
  try {
    const response = await api_client.post("/wheel/activity", data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 轉盤後台 - 獎品管理
export const getWheelPrizesAPI = async () => {
  try {
    const response = await api_client.get("/wheel/prizes");
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const saveWheelPrizeAPI = async (data) => {
  try {
    const response = await api_client.post("/wheel/prize", data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteWheelPrizeAPI = async (id) => {
  try {
    const response = await api_client.delete("/wheel/prize", { data: { id } });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 轉盤後台 - 報表
export const getWheelReportAPI = async (params) => {
  try {
    const response = await api_client.get("/wheel/report", { params });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const downloadWheelReportCSV = async (params) => {
  try {
    const response = await api_client.get("/wheel/report", {
      params: { ...params, format: "csv" },
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = `wheel_report_${params.start || ""}_${params.end || ""}.csv`;
    link.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    handleError(error);
  }
};

// 取得今日員工餐可使用員工
export const getStaffMealAPI = async () => {
  try {
    const response = await api_client.get("/staff_meal");
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 移除訂單 API 函數
export const removeOrder = async (order_id, data) => {
  try {
    const response = await api_client.delete("/order", {
      data: {
        order_id,
        ...data,
      },
    });
    if (response.data.error === 0 && response.data.msg) {
      toast.success(response.data.msg);
      return response.data;
    } else if(response.data.msg) {
      toast.error(response.data.msg);
    }
  } catch (error) {
    handleError(error);
  }
};

// 獲取食物狀態 API 函數
export const getFoods = async () => {
  try {
    const response = await api_client.get("/food_status");
    if (response.data.error === 0) {
      return response.data;
    }
  } catch (error) {
    handleError(error);
  }
};

// 暫停/停售品項的開始時間 { 品名: "Y-m-d H:i:s" }；只是輔助顯示，失敗不打擾操作
export const getPausedSinceAPI = async () => {
  try {
    const response = await api_client.get("/paused_since");
    if (response.data.error === 0) {
      return response.data.list || {};
    }
  } catch (error) {
    // 後端尚未部署或網路中斷時就不顯示暫停時間
  }
  return null;
};

// 修改食物狀態 API 函數
export const changeFoodStatus = async ({ name, status }) => {
  try {
    const response = await api_client.post("/food_status", {
      name,
      status,
    });
    if (response.data.error !== 0) {
      toast.error('修改失敗');
      const error = new Error(response.data.msg || "修改失敗");
      error.isHandled = true;
      throw error;
    }
    return response.data;
  } catch (error) {
    if (error.isHandled) {
      throw error;
    }
    handleError(error);
  }
};

// 批次修改食物狀態 API 函數
// 可傳 names[]（精確比對）或 keywords[]（後端用 LIKE 比對 ProductInfo + ProductDetail）
export const bulkChangeFoodStatus = async ({ names, keywords, status }) => {
  try {
    const payload = { status };
    if (names && names.length) payload.names = names;
    if (keywords && keywords.length) payload.keywords = keywords;
    const response = await api_client.post("/food_status_bulk", payload);
    if (response.data.error !== 0) {
      toast.error('批次修改失敗');
      const error = new Error(response.data.msg || "批次修改失敗");
      error.isHandled = true;
      throw error;
    }
    return response.data;
  } catch (error) {
    if (error.isHandled) {
      throw error;
    }
    handleError(error);
  }
};

// 打印訂單 API 函數
export const printOrder = async ({ type, orderId, date }) => {
  try {
    const response = await api_client.get("/print_order", {
      params: {
        order_id: orderId,
        type: type,
        ...(date ? { date } : {}),
      },
    });
    if (response.data.error === 0) {
      toast.success(response.data.msg);
    } else {
      toast.error(response.data.msg);
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const printOrderItemLabel = async ({ orderId, itemId, type = 2 }) => {
  try {
    const response = await api_client.get("/print_order", {
      params: {
        order_id: orderId,
        item_id: itemId,
        type,
        label_only: 1,
      },
    });
    if (response.data.error === 0) {
      toast.success(response.data.msg);
    } else {
      toast.error(response.data.msg);
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 獲取訂單狀態 API 函數
// silent：背景同步用（如選單紅字），失敗回 null、不跳錯誤提示
export const getOrderStatusAPI = async (urlType, { silent = false } = {}) => {
  try {
    const response = await api_client.get("/order_status?type="+urlType);
    // console.log("response",response);
    if (response.data.error === 0) {
      return response.data.list;
    } else if (silent) {
      return null;
    } else {
      toast.error("獲取訂單狀態失敗");
    }
  } catch (error) {
    if (silent) return null;
    handleError(error);
  }
  return [] ;
};

export const getIncomeAPI = async(params = {}) => {
  try{
    const response = await api_client.get("/income_data", { params });
    if(response.data.error === 0){
      return response.data ;
    }
  } catch(error){
    handleError(error);
  }
}

export const getCashCountsAPI = async (params = {}) => {
  try {
    const response = await api_client.get("/cash_counts", { params });
    if (response.data.error === 0) {
      return response.data;
    }
    toast.error(response.data.msg || "取得現金盤點紀錄失敗");
  } catch (error) {
    handleError(error);
  }
};

export const saveCashCountAPI = async (data, options = {}) => {
  try {
    const response = await api_client.post("/cash_count", data);
    if (response.data.error === 0) {
      if (!options.silent) toast.success(response.data.msg || "現金盤點已儲存");
    } else {
      toast.error(response.data.msg || "現金盤點儲存失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 補入現金：業主/店長把外部現金放進錢櫃（不是營收），立即計入當日應有現金
export const cashInAPI = async (data) => {
  try {
    const response = await api_client.post("/cash_count/cash_in", data);
    if (response.data.error === 0) {
      toast.success(response.data.msg || "已登記補入現金");
    } else {
      toast.error(response.data.msg || "補入現金登記失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteCashCountAPI = async ({ id }) => {
  try {
    const response = await api_client.post("/cash_count/delete", { id });
    if (response.data.error === 0) {
      toast.success(response.data.msg || "已刪除盤點紀錄");
    } else {
      toast.error(response.data.msg || "刪除盤點紀錄失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 盤點確認/取消確認：確認當下鎖定貨款快照並起算2小時修正期
export const confirmCashCountAPI = async ({ id, action = "confirm" }) => {
  try {
    const response = await api_client.post("/cash_count/confirm", { id, action });
    if (response.data.error === 0) {
      toast.success(response.data.msg || (action === "confirm" ? "盤點已確認" : "已取消確認"));
    } else {
      toast.error(response.data.msg || "盤點確認失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const printCashCountAPI = async (cashCountId) => {
  try {
    const response = await api_client.get("/cash_count/print", {
      params: {
        id: cashCountId,
      },
    });
    if (response.data.error === 0) {
      toast.success(response.data.msg || "執行列印");
    } else {
      toast.error(response.data.msg || "列印盤點明細失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 更新訂單狀態 API 函數
export const postOrderStatusAPI = async (id, type, kind) => {
  try {
    const payload = {
      id,
      type,
    };
    if (kind) payload.kind = kind;
    const response = await api_client.post("/order_status", payload);
    if (response.data.error !== 0) {
      toast.error(response.data.msg || "更新訂單狀態失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 下炸物標記 API：存後台 cache，跨機台同步（on=true 下鍋 / false 取消）
export const postFriedDropAPI = async (id, on) => {
  try {
    const response = await api_client.post("/fried_drop", { id, on: on ? 1 : 0 });
    if (response.data.error !== 0) {
      toast.error(response.data.msg || "更新下炸物狀態失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 取餐叫號（電視看板）：making 製作中、ready 請取餐、wait 預計等候
// silent：面板開著時的背景輪詢用，失敗回 null、不跳錯誤提示
export const getPickupBoardAPI = async ({ silent = false } = {}) => {
  try {
    const response = await api_client.get("/pickup_board");
    if (response.data.error === 0) {
      return response.data;
    }
    if (!silent) toast.error(response.data.message || response.data.msg || "取得取餐叫號失敗");
    return null;
  } catch (error) {
    if (silent) return null;
    handleError(error);
  }
};

// 標記已取餐（undo=true 復原）；silent：不跳 toast、不拋錯，失敗回 {error:1, message} 由呼叫端顯示
export const markPickupAPI = async (orderId, { undo = false, silent = false } = {}) => {
  try {
    const response = await api_client.post(`/pickup/${orderId}`, undo ? { undo: 1 } : {});
    if (response.data.error !== 0 && !silent) {
      toast.error(response.data.message || response.data.msg || "更新取餐狀態失敗");
    }
    return response.data;
  } catch (error) {
    if (silent && error.response?.status !== 401) {
      return {
        error: 1,
        message: error.response?.data?.message || (error.response ? "伺服器錯誤" : "網絡錯誤"),
      };
    }
    handleError(error);
  }
};

export const getInventoryVendorsAPI = async () => {
  try {
    const response = await api_client.get("/inventory_vendors");
    if (response.data.error === 0) {
      return response.data;
    }
  } catch (error) {
    handleError(error);
  }
};

export const getInventoryItemsAPI = async (params) => {
  try {
    const response = await api_client.get("/inventory_items", { params });
    if (response.data.error === 0) {
      return response.data;
    }
    toast.error(response.data.msg || "取得盤點資料失敗");
  } catch (error) {
    handleError(error);
  }
};

export const saveInventoryCheckAPI = async ({ food_id, num, date }) => {
  try {
    const response = await api_client.post("/inventory_check", {
      food_id,
      num,
      date,
    });
    if (response.data.error !== 0) {
      toast.error(response.data.msg || "盤點儲存失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const saveInventoryBuyNumAPI = async ({ food_id, num, date }) => {
  try {
    const response = await api_client.post("/inventory_buy_num", {
      food_id,
      num,
      date,
    });
    if (response.data.error !== 0) {
      toast.error(response.data.msg || "叫貨數量儲存失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const submitInventoryBuyAPI = async ({ vendor_id }) => {
  try {
    const response = await api_client.post("/inventory_buy", {
      vendor_id,
    });
    if (response.data.error === 0) {
      toast.success(response.data.msg || "已送出叫貨");
    } else {
      toast.error(response.data.msg || "叫貨失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getPurchaseVendorsAPI = async (params = {}) => {
  try {
    const response = await api_client.get("/purchase_vendors", { params });
    if (response.data.error === 0) {
      return response.data;
    }
    toast.error(response.data.msg || "取得進貨廠商失敗");
  } catch (error) {
    handleError(error);
  }
};

export const getPurchasesAPI = async (params = {}) => {
  try {
    const response = await api_client.get("/purchases", { params });
    if (response.data.error === 0) {
      return response.data;
    }
    toast.error(response.data.msg || "取得進貨明細失敗");
  } catch (error) {
    handleError(error);
  }
};

// multipart：金額+照片；重複時後端回 code=duplicate，由呼叫端確認後帶 force 重送
export const submitPurchaseAPI = async (formData) => {
  try {
    const response = await api_client.post("/purchase", formData, { timeout: 60000 });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const deletePurchaseAPI = async ({ id }) => {
  try {
    const response = await api_client.delete("/purchase", { params: { id } });
    if (response.data.error === 0) {
      toast.success(response.data.msg || "已刪除");
    } else {
      toast.error(response.data.msg || "刪除失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getPrepItemsAPI = async (params = {}) => {
  try {
    const response = await api_client.get("/prep_items", { params });
    if (response.data.error === 0) {
      return response.data;
    }
    toast.error(response.data.msg || "取得備置資料失敗");
  } catch (error) {
    handleError(error);
  }
};

export const savePrepItemAPI = async ({ prep_id, current_qty, made_qty, date, note }) => {
  try {
    const response = await api_client.post("/prep_item", {
      prep_id,
      current_qty,
      made_qty,
      date,
      note,
    });
    if (response.data.error === 0) {
      toast.success(response.data.msg || "已更新備置");
    } else {
      toast.error(response.data.msg || "備置更新失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getSopAPI = async (params = {}) => {
  try {
    const response = await api_client.get("/sop", { params });
    if (response.data.error === 0) {
      return response.data;
    }
    toast.error(response.data.msg || "取得 SOP 失敗");
  } catch (error) {
    handleError(error);
  }
};

export const getSopEmployeesAPI = async () => {
  try {
    const response = await api_client.get("/sop/employees");
    if (response.data.error === 0) {
      return response.data;
    }
    toast.error(response.data.msg || "取得今日上班人員失敗");
  } catch (error) {
    handleError(error);
  }
};

export const checkSopAPI = async ({ item_id, checked, employee_id }) => {
  try {
    const response = await api_client.post("/sop/check", {
      item_id,
      checked: checked ? 1 : 0,
      employee_id: employee_id || undefined,
    });
    if (response.data.error !== 0) {
      toast.error(response.data.msg || "更新失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// ===== 作業檢核：製作標籤 =====
export const getLabelItemsAPI = async () => {
  try {
    const response = await api_client.get("/label_items");
    if (response.data.error === 0) {
      return response.data;
    }
    toast.error(response.data.msg || "取得標籤品項失敗");
  } catch (error) {
    handleError(error);
  }
};

export const getLabelBatchesAPI = async (params = {}) => {
  try {
    const response = await api_client.get("/label_batches", { params });
    if (response.data.error === 0) {
      return response.data;
    }
    toast.error(response.data.msg || "取得列印紀錄失敗");
  } catch (error) {
    handleError(error);
  }
};

export const printLabelAPI = async ({ item_id, qty, note, employee_id, printer_type }) => {
  try {
    const response = await api_client.post("/label_print", {
      item_id,
      qty,
      note: note || "",
      employee_id: employee_id || undefined,
      printer_type: printer_type || undefined,
    });
    if (response.data.error === 0) {
      toast.success(response.data.msg || "已送出列印");
    } else {
      toast.error(response.data.msg || "列印失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const reprintLabelAPI = async ({ batch_id, qty }) => {
  try {
    const response = await api_client.post("/label_reprint", {
      batch_id,
      qty: qty || undefined,
    });
    if (response.data.error === 0) {
      toast.success(response.data.msg || "已送出補印");
    } else {
      toast.error(response.data.msg || "補印失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getStoreSettingsAPI = async () => {
  try {
    const response = await api_client.get("/store_settings");
    if (response.data.error === 0) {
      return response.data;
    }
    toast.error(response.data.msg || "取得營業資訊失敗");
  } catch (error) {
    handleError(error);
  }
};

export const saveStoreSettingsAPI = async (payload) => {
  try {
    const response = await api_client.post("/store_settings", payload);
    if (response.data.error === 0) {
      toast.success(response.data.msg || "已儲存");
    } else {
      toast.error(response.data.msg || "儲存失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 外送開關：目前狀態（營業資訊 > 營業時間）
// 預估「提前多久送到出餐管理」（外送含車程）；只是提示，失敗不跳錯誤
export const getKitchenLeadAPI = async (params) => {
  try {
    const response = await api_client.get("/kitchen_lead", { params });
    return response.data;
  } catch (error) {
    return null;
  }
};

export const getDeliveryStatusAPI = async () => {
  try {
    const response = await api_client.get("/delivery_status");
    if (response.data.error === 0) {
      return response.data;
    }
    toast.error(response.data.msg || "取得外送狀態失敗");
  } catch (error) {
    handleError(error);
  }
};

// 外送開關：{ mode: "open" | "pause" | "close", hours } ；成功時回傳含最新狀態的 payload
export const toggleDeliveryAPI = async (payload) => {
  try {
    const response = await api_client.post("/delivery_toggle", payload);
    if (response.data.error === 0) {
      toast.success(response.data.msg || "已更新外送狀態");
      return response.data;
    }
    toast.error(response.data.msg || "更新外送狀態失敗");
  } catch (error) {
    handleError(error);
  }
};

export const submitSopAPI = async ({ position_type, stage, inspector_name }) => {
  try {
    const response = await api_client.post("/sop/submit", {
      position_type,
      stage,
      inspector_name,
    });
    if (response.data.error === 0) {
      toast.success(response.data.msg || "已送出巡視");
    } else {
      toast.error(response.data.msg || "送出失敗");
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

const recentErrorMessages = {};

const showErrorToast = (message) => {
  const now = Date.now();
  if (recentErrorMessages[message] && now - recentErrorMessages[message] < 3000) {
    return;
  }
  recentErrorMessages[message] = now;
  toast.error(message);
};

// 統一的錯誤處理函數
const handleError = (error) => {
  if (error.__handled || error.response?.status === 401) {
    throw error;
  }

  if (error.response) {
    showErrorToast(error.response.data.message || "伺服器錯誤");
  } else {
    showErrorToast("網絡錯誤");
  }
  throw error;
};

// 報廢管理（docs/superpowers/specs/2026-10-10-cost-and-waste-management-design.md 第 5 節）
export const getWasteOptionsAPI = async () => {
  try {
    const response = await api_client.get("/waste/options");
    if (response.data.error === 0) {
      return response.data;
    }
    toast.error(response.data.msg || "取得報廢選項失敗");
  } catch (error) {
    handleError(error);
  }
};

/** 分頁清單（新到舊）：回傳 {records, total, page, per_page, total_loss, uncosted}；date 空白＝不限日期。 */
export const getWasteRecordsAPI = async ({ page = 1, date, source } = {}) => {
  try {
    const params = { page };
    if (date) params.date = date;
    if (source && source !== "all") params.source = source;
    const response = await api_client.get("/waste/records", { params });
    if (response.data.error === 0) {
      return response.data;
    }
    toast.error(response.data.msg || "取得報廢清單失敗");
  } catch (error) {
    handleError(error);
  }
};

export const saveWasteRecordAPI = async (data) => {
  try {
    const response = await api_client.post("/waste/record", data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteWasteRecordAPI = async (id) => {
  try {
    const response = await api_client.delete("/waste/record", { data: { id } });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const uploadWastePhotoAPI = async (id, blob) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("photo", blob, `waste_${id}.jpg`);
  try {
    const response = await api_client.post("/waste/photo", formData, { timeout: 60000 });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const remakeOrderItemAPI = async (data) => {
  try {
    const response = await api_client.post("/waste/remake", data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
